import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useLoginStore } from '@/shared/lib/store/model/login.store';
import { useEffect, useMemo, useState } from 'react';
import { ErrorPopup } from '@/shared/ui/index';
import { usePersistStore } from '@/shared/lib/store';
import { useCreateStore } from '@/entities/create/model/create.store';
import { createQueries } from '@/entities/create/model/create.queries';
import { useModalStore } from '@/shared/lib/store/model/modal.store';
import { AutoCreateLayout } from '@/widgets/import/auto-create-layout';
import { FilterPopup } from '@/widgets/modal/ui/filter-popup';
import { useLoadingStore } from '@/shared/lib/store/model/loading.store';
import { sendTraceLog } from '@/shared/log/tracker';
import { QuestionFilterSearchPopup } from '@/widgets/modal/ui/question-filter-search-popup';

export const Route = createFileRoute('/edit/')({
    component: RouteComponent,
});

function RouteComponent() {
    const router = useRouter();
    const { showModal } = useModalStore();
    // 검색 필터 체크 리스트

    const { textbookId } = useLoginStore();
    const { sUserId, sBrandId } = usePersistStore();
    const {
        type,
        sCurribookId,
        sCurribook,
        fetchMetaData,
        questionTypeList,
        sourceTypeList,
        setSTopMap,
        editSubjectId,
        fetchInitSetList,
        sTopMap,
    } = useCreateStore();

    const [currentHash, setCurrentHash] = useState(router.history.location.hash);
    const [selected, setSelected] = useState<number[][]>([[], [], []]);
    const [filterSelected, setFilterSelected] = useState<number[][]>([[], [], []]); // 텍스트북을 제외한 커리ID중 가장 하위항목만 필터링
    const [openSelected, setOpenSelected] = useState<number[][]>([[], [], []]); // 뎁스 오픈 리스트

    // 문항 검색 저장
    const [sourceType, setSourceType] = useState<CheckSelectTableData[]>([]);
    const [selectedEval, setSelectedEval] = useState<CheckSelectTableData[]>([]);
    const [isExceptQuestion, setIsExceptQuestion] = useState(false);
    const [isExceptChain, setIsExceptChain] = useState<boolean>(false);
    const [articleList, setArticleList] = useState<DATA.ArticleInfo[]>();
    const [difficultyList, setDifficultyList] = useState<API.MetaSearch.MetaData[]>();
    const [questionType, setQuestionType] = useState<number[]>([]);
    const [selectDifficulty, setSelectDifficulty] = useState<CheckSelectTableData[]>([]);
    const [selectedQuestion, setSelectedQuestion] = useState<CheckSelectTableData[]>([]);
    const [selectedType, setSelectedType] = useState('auto');
    const [high, setHigh] = useState(5);
    const [middle, setMiddle] = useState(10);
    const [low, setLow] = useState(5);
    const [difficultyCountList, setDifficultyCountList] = useState<any[]>([]);
    const [dataTypeList, setDataTypeList] = useState<API.MetaSearch.MetaData[]>();
    const [evalAreaList, setEvalAreaList] = useState<API.MetaSearch.MetaData[]>();
    const [initData, setIsInitData] = useState<boolean>(false);
    const [mapCode, setMapCode] = useState<string>('');
    const postMetaDataType = createQueries.import.postMetaSearchDataTypeList();
    const postMetaDataEvalArea = createQueries.import.postMetaSearchDataEvalAreaList();
    const postMetaDifficulty = createQueries.import.postMetaSearchDifficultyList();
    const postStudyMap = createQueries.import.postStudyMap();
    const { data: descendantsData } = createQueries.import.getDescendants(mapCode);

    const { showLoading, hideLoading } = useLoadingStore();
    // const { data: resultSourceType } = createQueries.textbook.getMetaList({
    //     name: 'sourceType',
    // });

    // const { data: resultQuestionType } = createQueries.textbook.getMetaList({
    //     name: 'questionType',
    // });

    const converQuestionType = [
        { id: 1, val: '객관식' },
        { id: 2, val: '주관식' },
        { id: 3, val: '서술형' },
    ];

    // const convertSourceTypeList = useMemo(
    //     () => resultSourceType?.vo?.map(({ id, val }) => ({ id, val })),
    //     [resultSourceType]
    // );

    const converEvalList = useMemo(
        () => evalAreaList?.map(({ id, val }) => ({ id, val })),
        [evalAreaList]
    );

    const pruneTwoLevels = (
        parentLevel: number[],
        childLevel: number[],
        data: API.MetaSearch.MetaData[]
    ): number[] => {
        return parentLevel?.filter((parentId) => {
            const hasChildWithThisParent = childLevel.some((childId) => {
                const childData = data.find((item) => item.id === childId);
                return childData?.parent_id === parentId;
            });
            return !hasChildWithThisParent;
        });
    };

    const recursivePrune = (levels: number[][], data: API.MetaSearch.MetaData[]): number[][] => {
        if (levels.length < 2) {
            return levels;
        }

        const prunedParent = pruneTwoLevels(levels[0], levels[1], data);

        const prunedRemaining = recursivePrune(levels.slice(1), data);

        return [prunedParent, ...prunedRemaining];
    };

    useEffect(() => {
        if (descendantsData)
            setFilterSelected(recursivePrune(selected, descendantsData ?? [[], [], []]));
    }, [selected, descendantsData]);

    useEffect(() => {
        if (sBrandId) {
            fetchMetaData();
            fetchAllData();
        }
    }, []);

    useEffect(() => {
        if (sBrandId) {
            fetchMetaData();
            fetchAllData();
        }
        // if (type !== 'data') setState('type', 'setMode');
    }, [textbookId, sBrandId]);

    useEffect(() => {
        if (descendantsData) {
            setSTopMap(descendantsData.filter((el) => el.depth === 1 && el.is_active === true)[0]);
        }
    }, [descendantsData]);

    const convertDifficultyList = useMemo(
        () =>
            difficultyList
                ?.filter((el) => el.val !== '중하' && el.val !== '중상')
                .map(({ id, val }) => ({ id, val })),
        [difficultyList]
    );

    const middleDifficultyList = useMemo(
        () =>
            difficultyList
                ?.filter((el) => el.val === '중하' || el.val === '중상')
                .map(({ id, val }) => id),
        [difficultyList]
        // const middleData = difficultyList?.filter((el) => el.val === '중');
        // if (middleData && selectDifficulty.some((el) => el.id === middleData[0].id)) {
        //     difList.push(...middleDifficultyList!);
        // }
    );
    const initCheckData = () => {
        setSelected([[], [], []]);
        setFilterSelected([[], [], []]);
        setOpenSelected([[], [], []]);
        if (sourceTypeList) setSourceType(sourceTypeList);
        if (converQuestionType) setSelectedQuestion(converQuestionType);
        if (convertDifficultyList) setSelectDifficulty(convertDifficultyList);
        if (evalAreaList) setSelectedEval(converEvalList!);
        setIsExceptQuestion(false);
        setHigh(5);
        setMiddle(10);
        setLow(5);
    };

    useEffect(() => {
        initCheckData();
    }, [sourceTypeList, questionTypeList, converEvalList, convertDifficultyList]);

    useEffect(() => {
        initCheckData();
    }, []);

    const handleCloseAndSubmit = (
        selected: number[][],
        type: CheckSelectTableData[],
        evaluatuon: CheckSelectTableData[],
        question: CheckSelectTableData[],
        isExcept: boolean,
        _high: number,
        _middle: number,
        _low: number
    ) => {
        const highData = difficultyList?.filter((el) => el.val === '상');
        const middleData = difficultyList?.filter((el) => el.val === '중');
        const lowData = difficultyList?.filter((el) => el.val === '하');

        const diffList = [];
        let data = selected;

        if (highData?.[0]) {
            diffList.push({
                metaId: highData[0].id,
                limitCount: _high,
            });
        }

        if (middleData?.[0]) {
            diffList.push({
                metaId: middleData[0].id,
                limitCount: _middle,
            });
        }

        if (lowData?.[0]) {
            diffList.push({
                metaId: lowData[0].id,
                limitCount: _low,
            });
        }

        if (descendantsData) {
            data = recursivePrune(selected, descendantsData ?? [[], [], []]);
        }
        const studyMap =
            data!.flat().length === 0 ? (sTopMap?.id ? [sTopMap.id] : []) : data!.flat();
        const total = _high + _middle + _low;
        const questionType = converQuestionTypeList(question);
        fetchInitSetList(
            sBrandId!,
            sCurribookId!,
            type.map((el) => el.id),
            questionType,
            diffList,
            studyMap,
            evaluatuon.map((el) => el.id),
            total,
            false,
            isExcept,
            sUserId
        );
    };

    const showFilterPopup = () => {
        showModal({
            isCustom: true,
            id: 'filter-popup',
            initContents: () => (
                <FilterPopup
                    convertDifficultyList={convertDifficultyList}
                    selectedQuestion={selectedQuestion}
                    setSelectedQuestion={setSelectedQuestion}
                    selectDifficulty={selectDifficulty}
                    setSelectDifficulty={setSelectDifficulty}
                    selectedEval={selectedEval}
                    setSelectedEval={setSelectedEval}
                    evalAreaList={evalAreaList}
                    isExceptChain={isExceptChain}
                    setIsExceptChain={setIsExceptChain}
                />
            ),
        });
    };

    const fetchAllData = async () => {
        try {
            showLoading(); // 로딩 시작
            sendTraceLog('', '', '', 'debug', '[SBANK_LOG] init curribook = ', sCurribookId);
            const studyMapPromise = new Promise<void>((resolve, reject) => {
                postStudyMap.mutate(
                    {
                        brand_id: sBrandId!,
                        curriBook: sCurribookId,
                    },
                    {
                        onSuccess: (res: API.StudyMap.Res | undefined) => {
                            if (res) setMapCode(res.vo[0].code);
                            resolve();
                        },
                        onError: () => {
                            router.history.back();
                            showModal({
                                isCustom: true,
                                id: 'error',
                                initContents: () => <ErrorPopup />,
                            }),
                                reject();
                        },
                    }
                );
            });

            const difficultyPromise = new Promise<void>((resolve, reject) => {
                postMetaDifficulty.mutate(
                    {
                        brand_id: sBrandId!,
                        name: 'difficulty',
                    },
                    {
                        onSuccess: (res: API.MetaSearch.Res | undefined) => {
                            if (res) setDifficultyList(res.vo);
                            resolve();
                        },
                        onError: reject,
                    }
                );
            });

            const dataTypePromise = new Promise<void>((resolve, reject) => {
                postMetaDataType.mutate(
                    {
                        brand_id: sBrandId!,
                        name: 'evaluationType',
                        metaMap: [{ name: 'curriBook', id: sCurribookId! }],
                    },
                    {
                        onSuccess: (res: API.MetaSearch.Res | undefined) => {
                            if (res) {
                                let list = res.vo.filter((el) => el.is_active === true);
                                const order = [60144, 60131]; // 총괄, 서술형 순으로 순서조정 맨뒤로 보냄
                                list.sort((a, b) => {
                                    const indexA = order.findIndex((o) => a.id === o);
                                    const indexB = order.findIndex((o) => b.id === o);

                                    if (indexA !== -1 && indexB !== -1) {
                                        return indexA - indexB;
                                    }
                                    if (indexA !== -1) return 1;
                                    if (indexB !== -1) return -1;
                                    return 0;
                                });

                                if (sCurribookId === 36598) {
                                    // 고등 세계사 수행평가 삭제
                                    list = list.filter((el) => el.id !== 60138);
                                }

                                setDataTypeList(list);
                            }
                            resolve();
                        },
                        onError: reject,
                    }
                );
            });

            const evalAreaPromise = new Promise<void>((resolve, reject) => {
                const subject = sCurribook?.curriBookSubject
                    ? sCurribook?.curriBookSubject
                    : sCurribook?.curriSubject;
                postMetaDataEvalArea.mutate(
                    {
                        brand_id: sBrandId!,
                        name: 'evaluationArea',
                        metaMap: [
                            {
                                name: 'curriSubject',
                                id:
                                    type === 'editMode'
                                        ? editSubjectId
                                            ? editSubjectId
                                            : subject!
                                        : subject!,
                            },
                        ],
                        orderby_col: 'id',
                        orderby_dir: 'asc',
                    },
                    {
                        onSuccess: (res: API.MetaSearch.Res | undefined) => {
                            if (res) setEvalAreaList(res.vo.filter((el) => el.is_active === true));
                            resolve();
                        },
                        onError: reject,
                    }
                );
            });

            await Promise.all([
                studyMapPromise,
                difficultyPromise,
                dataTypePromise,
                evalAreaPromise,
            ]);
            setIsInitData(true);
            initCheckData();
        } catch (error) {
            console.error('데이터 로드 중 오류 발생:', error);
        } finally {
            sendTraceLog('', '', '', 'debug', `[SBANK_LOG] init finish`);
            hideLoading(); // 로딩 종료
        }
    };

    const converQuestionTypeList = (selectQuestion: CheckSelectTableData[]): number[] => {
        let ret: number[] = [];
        if (questionTypeList) {
            if (selectQuestion.some((item) => item.id === 1)) {
                ret = ret.concat(
                    questionTypeList
                        .filter(
                            (el) =>
                                el.val === '단일선택형' ||
                                el.val === '다중선택형' ||
                                el.val === 'TF형' ||
                                el.val === '연결형' ||
                                el.val === 'OX형'
                        )
                        .map((el) => el.id)
                );
            }

            if (selectQuestion.some((item) => item.id === 2)) {
                ret = ret.concat(
                    questionTypeList
                        .filter(
                            (el) =>
                                el.val === '단답형' ||
                                el.val === '순서 입력형' ||
                                el.val === '순서 조합형'
                        )
                        .map((el) => el.id)
                );
            }

            if (selectQuestion.some((item) => item.id === 3)) {
                ret = ret.concat(
                    questionTypeList.filter((el) => el.val === '서술형').map((el) => el.id)
                );
            }
        }
        return ret;
    };

    useEffect(() => {
        const ret: number[] = converQuestionTypeList(selectedQuestion);

        setQuestionType(ret);
    }, [selectedQuestion]);

    useEffect(() => {
        const highData = difficultyList?.filter((el) => el.val === '상');
        const middleData = difficultyList?.filter((el) => el.val === '중');
        const lowData = difficultyList?.filter((el) => el.val === '하');

        const diffList = [];

        if (highData?.[0]) {
            diffList.push({
                metaId: highData[0].id,
                limitCount: high,
            });
        }

        if (middleData?.[0]) {
            diffList.push({
                metaId: middleData[0].id,
                limitCount: middle,
            });
        }

        if (lowData?.[0]) {
            diffList.push({
                metaId: lowData[0].id,
                limitCount: low,
            });
        }

        setDifficultyCountList(diffList);
    }, [high, low, middle, selectedType, selectDifficulty, difficultyList]);

    useEffect(() => {
        // 해시 변경 감지 및 업데이트
        const unsubscribe = router.history.subscribe(() => {
            setCurrentHash(router.history.location.hash);
        });

        return () => unsubscribe(); // 컴포넌트 언마운트 시 구독 해제
    }, [router]);

    const showResearchPopup = () => {
        showModal({
            isCustom: true,
            id: 'research-popup',
            initContents: () => (
                <QuestionFilterSearchPopup
                    selected={selected!}
                    setSelected={setSelected}
                    openSelected={openSelected}
                    setOpenSelected={setOpenSelected}
                    sourceType={sourceType}
                    setSourceType={setSourceType}
                    convertSourceTypeList={sourceTypeList}
                    selectedQuestion={selectedQuestion}
                    setSelectedQuestion={setSelectedQuestion}
                    selectedEval={selectedEval}
                    setSelectedEval={setSelectedEval}
                    evalAreaList={converEvalList}
                    convertDifficultyList={convertDifficultyList}
                    selectDifficulty={selectDifficulty}
                    setSelectDifficulty={setSelectDifficulty}
                    difficultyCountList={difficultyCountList}
                    isExceptChain={isExceptChain}
                    setIsExceptChain={setIsExceptChain}
                    pageType={'edit'}
                />
            ),
        });
    };

    return (
        <section className="contwrap importCont">
            {initData && (
                <div className="contInner" id="confirmQuestion">
                    <AutoCreateLayout
                        articleList={articleList}
                        setArticleList={setArticleList}
                        sourceType={sourceType}
                        questionType={questionType}
                        isExceptQuestion={isExceptQuestion}
                        isExceptChain={isExceptChain}
                        selectedEval={selectedEval}
                        selected={selected}
                        filterSelected={filterSelected}
                        selectedType={selectedType}
                        selectedQuestion={selectedQuestion}
                        selectDifficulty={selectDifficulty}
                        showFilterPopup={showFilterPopup}
                        showResearchPopup={showResearchPopup}
                        pageType={'edit'}
                    />
                </div>
            )}
        </section>
    );
}
